module.exports = __webpack_public_path__ + "media/bg.6c265daa.mp3";